// extracted by mini-css-extract-plugin
export var infoItem = "_ua-2";
export var title = "_ua-0";
export var value = "_ua-1";